import BillingSection from './BillingSection';

interface BillingDashboardProps {
  onNavigateToUpgrade?: () => void;
}

const BillingDashboard = ({ onNavigateToUpgrade }: BillingDashboardProps) => {
  return <BillingSection onNavigateToUpgrade={onNavigateToUpgrade} />;
};

export default BillingDashboard;
